import type { StaffTableRow } from '../types';

export type StaffTableRowKeys = keyof Pick<StaffTableRow, 'fullName' | 'email' | 'rolesLabel'>;

export const SORT_KEYS: Record<string, StaffTableRowKeys> = {
  fullName: 'fullName',
  email: 'email',
  rolesLabel: 'rolesLabel',
};

type SortKeyRecordKey = keyof typeof SORT_KEYS;
export type SortKeyRecordValue = (typeof SORT_KEYS)[SortKeyRecordKey];
